module.exports = "<template> <slot> <tcw-icon-button> <button type=button> <tcw-avatar></tcw-avatar> </button> </tcw-icon-button> </slot> </template>";